import * as angular from "angular";

export const TOKEN_SERVICE = "tokenService";

export class TokenService {
    boardWebAdminAccessToken: string;
    boardWebAccessToken: string;

    onAdminTokenChange: () => void;

    static $inject = ["BoardWebAdminUserManager", "BoardWebUserManager", "BoardWebAdminUser", "BoardWebUser", "IDP_ENDPOINT"];
    constructor(private adminUserManager: Oidc.UserManager, private webUserManager: Oidc.UserManager, adminUser: Oidc.User, webUser: Oidc.User, idpEndpoint: string) {
        adminUserManager.events.removeUserLoaded(this.boardWebAdminUserLoaded);
        adminUserManager.events.addUserLoaded(this.boardWebAdminUserLoaded);
        if (idpEndpoint) {
            adminUserManager.events.addUserSignedOut(() => { // Single signout
                adminUserManager.removeUser().then(() => {
                    adminUserManager.signinRedirect({ state: location.toString() });
                });
            });
        }

        webUserManager.events.removeUserLoaded(this.boardWebUserLoaded);
        webUserManager.events.addUserLoaded(this.boardWebUserLoaded);

        this.boardWebAdminAccessToken = adminUser.access_token;
        if (webUser !== null) {
            this.boardWebAccessToken = webUser.access_token;
        }
    }

    private boardWebAdminUserLoaded = (user: Oidc.User) => {
        this.boardWebAdminAccessToken = user.access_token;
        //console.log(`new token web admin - ${user.access_token}`);
    }

    private boardWebUserLoaded = (user: Oidc.User) => {
        this.boardWebAdminAccessToken = user.access_token;
        //console.log(`new token web - ${user.access_token}`);
    }

}


// WEBPACK FOOTER //
// ./app/core/token.service.ts